import { TypeChecker } from '@attain-apps/type-guards'

/**
 * A PMS Upload payment type value used as a payment/document reference.
 */
export type Type = string
export namespace Type {
  export const isType: TypeChecker<Type> = TypeChecker.isString
}
